/** Ordered color stops of the 130deg Bizy brand gradient. */
export const BIZY_GRADIENT_STOPS = [
	{ hex: '#C5E8BA', position: '0%' },
	{ hex: '#70C481', position: '24%' },
	{ hex: '#B3EBE8', position: '55%' },
	{ hex: '#9783EA', position: '100%' },
] as const;

const withAlpha = (hex: string, alpha: number) => {
	const red = parseInt(hex.slice(1, 3), 16);
	const green = parseInt(hex.slice(3, 5), 16);
	const blue = parseInt(hex.slice(5, 7), 16);
	return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};

/**
 * Builds the Bizy brand gradient. Without alphas it's the solid gradient the
 * prompt buttons use; per-stop alphas produce lightened washes (e.g. the AI
 * settings zero-state glow).
 */
export const bizyGradient = (alphas?: readonly [number, number, number, number]) =>
	`linear-gradient(130deg, ${BIZY_GRADIENT_STOPS.map(({ hex, position }, index) => `${alphas ? withAlpha(hex, alphas[index]) : hex} ${position}`).join(', ')})`;

const PROMPT_GRADIENT = bizyGradient();

/**
 * Bizy prompt gradient border styling, used by `<PromptButton>` and
 * `<BizyPromptButton>` to give Bizy-related calls-to-action a consistent
 * gradient outline that swaps the inner fill on hover.
 *
 * Both modes fill the inside of the gradient border with the surface color so
 * the prompt reads as a button with only its 1px border carrying the gradient.
 * Hover swaps the inner fill to a subtly lifted background for affordance.
 */
export const promptGradientBorderSx = {
	border: '1px solid transparent',
	backgroundImage: `linear-gradient(var(--chakra-colors-bg-surface), var(--chakra-colors-bg-surface)), ${PROMPT_GRADIENT}`,
	backgroundOrigin: 'padding-box, border-box',
	backgroundClip: 'padding-box, border-box',
	'&:hover': {
		border: '1px solid transparent',
		backgroundImage: `linear-gradient(var(--chakra-colors-bg-subtle), var(--chakra-colors-bg-subtle)), ${PROMPT_GRADIENT}`,
	},
	'.chakra-ui-dark &:hover': {
		backgroundImage: `linear-gradient(var(--chakra-colors-bg-soft), var(--chakra-colors-bg-soft)), ${PROMPT_GRADIENT}`,
	},
};
